import { Chart, registerables } from "chart.js"

export const initChartJsConfigs = () => {
  Chart.register(...registerables)
}
